import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { SeismicCrewDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
@Component({
  selector: 'cradua-seismic-crew-container',
  templateUrl: './seismic-crew-container.component.html',
  styleUrls: ['./seismic-crew-container.component.scss']
})
export class SeismicCrewContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  seismiccrews$: Observable<SeismicCrewDto[]>;
  loading: boolean;
  isLoadingSeismicCrew$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingSeismicCrew$ = this.gatwayFacade.isLoadingGateway("SeismicCrew");
    this.seismiccrews$ = this.gatwayFacade.loadGateway("SeismicCrew");

    
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteSeismicCrew(deletedValue: any) {
    this.gatwayFacade.remove("SeismicCrew", deletedValue);
  }


// this method control both the create and update

  onSubmitSeismicCrew(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.SeismicCrews;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllSeismicCrew = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllSeismicCrew.push(pullData[i]);
    }
  }

// check if the addAllSeismicCrew array is not empty, then dispatch the data to the store
   if(addAllSeismicCrew.length > 0) {
    this.gatwayFacade.add('SeismicCrew', addAllSeismicCrew);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('SeismicCrew', allUpdates, ['id']);
  }

   }


}
